import React, { useState } from "react"
import { Button, Div, Text } from "atomize"

// Il contenuto dell'avviso "versione nuova": lo mostra
// `serviceWorkerRegistration.js` dentro un toast, che gli passa
// `closeToast`.
function UpdatePrompt({ onUpdate, closeToast }) {
	const [isUpdating, setIsUpdating] = useState(false)

	const update = async () => {
		setIsUpdating(true)
		await onUpdate()
	}

	return (
		<Div>
			<Text textColor="white" m={{ b: "0.6rem" }}>
				È pronta una versione nuova di inCampo
			</Text>
			<Div d="flex" style={{ gap: "0.5rem" }}>
				<Button
					h="2.25rem"
					p={{ x: "1rem" }}
					rounded="20px"
					bg="white"
					textColor="gunmetal_fill"
					textWeight="bold"
					disabled={isUpdating}
					onClick={update}>
					{isUpdating ? "Aggiorno..." : "Aggiorna"}
				</Button>
				{!isUpdating && (
					<Button
						h="2.25rem"
						p={{ x: "1rem" }}
						rounded="20px"
						bg="transparent"
						textColor="white"
						onClick={closeToast}>
						Dopo
					</Button>
				)}
			</Div>
		</Div>
	)
}

export default UpdatePrompt
